import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

i18n
    .use(HttpBackend) // Loads translations from public folder
    .use(initReactI18next)
    .init({
        lng: 'en', // default language
        fallbackLng: 'en',
        backend: {
            loadPath: './locale/{{lng}}/common.json',
        },
        interpolation: {
            escapeValue: false, // react already escapes
        },
    });

export default i18n;